/** @jsx jsx */
/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import { jsx } from '@emotion/core'
import { sectionCss } from './style'
import React from 'react'
import Icons from './icons'
import { show, showModal, fmt, arrayFrom, format, isNumeric, parseHtml } from '../../twd/all'

export const DetailMobile = ({detail, action}) => {
    const isCancel = action==='cancel'
    const isConfirm = action==='confirm'

    const title = isCancel ? 'Your request to cancel this order has been submitted'
        : isConfirm ? 'Your bonds order has been placed'
        : ''
    const status = isCancel ? 'Cancellation request in process'
        : isConfirm ? 'Open'
        : ''

    const netMoneyLabel = ['B','S'].indexOf(detail.action)>=0 ? 'Estimated proceeds'
        : 'Estimated total cost'

    return <React.Fragment>
        <div className="vertical-offset-base"></div>

        <div className="row vertical-offset-base">
        <div className="col-md-12 text-center">
            <p>{Icons.ok}</p>
            <h2>{title}</h2>
        </div>
        </div>

        <div className="row vertical-offset-base"><div className="col-xs-12">
            <h3>Order# { detail.orderNo }: {status}</h3>
        </div></div>

        <div className="row vertical-offset-base"><div className="col-xs-12">
            <div>{ format.mdy(new Date()) }</div>
            <div>{detail.accountNo} { parseHtml(detail.accountName) }</div>
        </div></div>

        <hr aria-hidden={true} className="vertical-offset-base" />

        <Labeled label="Action" value={detail.transactionType} style={{color:actionTypeColor(detail.action)}} />
        <Labeled label="Issuer" value={fmt.issuer({
                issuer: parseHtml(detail.issue),
                cusip: arrayFrom(detail.cusip).join(''),
                showTradeHistory: 'Y',
                from:'order-cancel'
            })} />
        <Labeled label="CUSIP" value={detail.cusip} />
        <Labeled label="Quantity" value={fmt.qty(detail.quantity)} />
        <Labeled label="Settlement date" value={detail.settlement} />
        <Labeled label="Status" value={detail.ordStatusDesc || fmt.empty()} />
        <Labeled label="Price" value={isNumeric(detail.clientPrice) ? '$' + fmt.price3(detail.clientPrice) : fmt.empty()} />

        <hr aria-hidden={true} className="vertical-offset-base" />

        <Labeled label="Principal" value={detail.principal || fmt.empty()} />
        <Labeled label="Accrued interest" value={
                detail.accruedInterest
                ? <React.Fragment>{detail.accruedInterest} ({detail.accIntDays} days)</React.Fragment>
                : fmt.empty()} />
        <Labeled label="Commission" value={detail.estCommission || fmt.empty()} />
        <Labeled label={netMoneyLabel} value={detail.netMoney || fmt.empty()} />

        <div className="row vertical-offset-base"><div className="col-md-12 text-center">
        {[
            isConfirm && <React.Fragment key={1}>
            <button
                data-name="cancel-link"
                className="btn btn-link text-bold"
                onClick={(e) => {
                    showModal({
                        view: 'order-detail',
                        action: 'cancel',
                        orderNo: detail.orderNo,
                        source: e.target,
                    })

                }}
            >Cancel</button>
            </React.Fragment>,

            isCancel && <React.Fragment key={2}>
            <button
                data-name="cancel-link"
                className="btn btn-link text-bold"
                onClick={(e) => {
                    show('overview')
                }}
            >Bond Resource Center</button>
            </React.Fragment>,

            <a href="#"
                key={3}
                data-name="orders-link"
                className="btn btn-link text-bold"
                onClick={() => {
                    show('orders', { backFrom:true, _ts:Date.now()})
                }}
            >View orders</a>,

            isConfirm && <React.Fragment key={4}>
            <button
                data-name="orders-link"
                className="btn btn-link text-bold"
                onClick={(e) => {
                    showModal({
                        view: 'holdings',
                        acctNo: detail.accountNo,
                        source: e.target,
                    })
                }}
            >View portfolio</button>
            </React.Fragment>,
        ]
        .filter(Boolean)
        .flatMap( (a,i) => [a, <Sep key={i} />])
        .slice(0, -1)
        }
        </div></div>

        </React.Fragment>
}

const Labeled = ({label, value, style={}}) => {
    return <div className="row vertical-offset-base"><div className="col-md-12">
        <div className="text-body">{label}</div>
        <div className="label text-body text-bold" ><span style={style}>{value}</span></div>
        </div></div>
}


export const Detail = ({detail, action}) => {
    const isCancel = action==='cancel'
    const isConfirm = action==='confirm'

    const title = isCancel ? 'Your request to cancel this order has been submitted'
        : isConfirm ? 'Your bonds order has been placed'
        : ''
    const status = isCancel ? 'Cancellation request in process'
        : isConfirm ? 'Open'
        : ''

    const netMoneyLabel = ['B','S'].indexOf(detail.action)>=0 ? 'Estimated proceeds'
        : 'Estimated total cost'

    return <React.Fragment>
        <div className="vertical-offset-base"></div>

        <div css={sectionCss}>
            <div className="row vertical-offset-base"></div>

            <div className="row vertical-offset-base">
            <div className="col-md-12 text-center">
                <p>{Icons.ok}</p>
                <h2>{title}</h2>
            </div>
            </div>

            <div className="row vertical-offset-base">
            <div className="col-md-6">
                <h3>Order# { detail.orderNo }: {status}</h3>
            </div>
            <div className="col-md-6 text-right">
                <div>{ format.mdy(new Date()) }</div>
                <div>{detail.accountNo} { parseHtml(detail.accountName) }</div>
            </div>
            </div>

            <div className="row">
            <div className="table-responsive">
                <table
                    data-name="orders-cancel-table"
                    className="table align-top"
                >
                <thead>
                    <tr>
                    <th className="text-body">Action</th>
                    <th className="text-body"style={{maxWidth:'250px'}}>Issuer</th>
                    <th className="text-body">CUSIP</th>
                    <th className="text-body">Quantity</th>
                    <th className="text-body text-right">Settlement Date</th>
                    <th className="text-body text-right">Status</th>
                    <th className="text-body text-right">Price</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{height:'50px'}}>
                    <td className="text-body text-bold"><span style={{color:actionTypeColor(detail.action)}}>{detail.transactionType}</span></td>
                    <td className="text-body text-bold" style={{maxWidth:'250px'}}>
                    {fmt.issuer({
                        issuer:detail.issue,
                        cusip: arrayFrom(detail.cusip).join(''),
                        showTradeHistory: 'Y',
                        from:'orders-cancel'
                    })}
                    </td>
                    <td className="text-body text-bold">{detail.cusip}</td>
                    <td className="text-body">{fmt.qty(detail.quantity)}</td>
                    <td className="text-body text-right">{detail.settlement}</td>
                    <td className="text-body text-right">{detail.ordStatusDesc || fmt.empty()}</td>
                    <td className="text-body text-right text-bold">{isNumeric(detail.clientPrice) ? '$' + fmt.price3(detail.clientPrice) : fmt.empty()}</td>
                    </tr>

                    <tr>
                    <td className="text-body">
                        <div>Principal</div>
                        <div className="text-bold">{detail.principal || fmt.empty()}</div>
                    </td>
                    <td className="text-body">
                        <div>Accrued interest</div>
                        <div className="text-bold">{detail.accruedInterest ? <React.Fragment>{detail.accruedInterest} ({detail.accIntDays} days)</React.Fragment> : fmt.empty()}</div>
                    </td>
                    <td className="text-body">
                        <div>Commission</div>
                        <div className="text-bold">{detail.estCommission || fmt.empty()}</div>
                    </td>
                    <td className="text-body">
                        <div>{netMoneyLabel}</div>
                        <div className="text-bold">{detail.netMoney || fmt.empty()}</div>
                    </td>
                    <td className="text-body text-right" colSpan={3} style={{verticalAlign:'middle'}}>
                    {[
                        isConfirm && <React.Fragment key={1}>
                        <button
                            data-name="cancel-link"
                            className="btn btn-link text-bold"
                            onClick={(e) => {
                                showModal({
                                    view: 'order-detail',
                                    action: 'cancel',
                                    orderNo: detail.orderNo,
                                    source: e.target,
                                })

                            }}
                        >Cancel</button>
                        </React.Fragment>,

                        isCancel && <React.Fragment  key={2}>
                        <button
                            data-name="cancel-link"
                            className="btn btn-link text-bold"
                            onClick={(e) => {
                                show('overview')
                            }}
                        >Bond Resource Center</button>
                        </React.Fragment>,

                        <a href="#"
                            key={3}
                            data-name="orders-link"
                            className="btn btn-link text-bold"
                            onClick={() => {
                                show('orders', { backFrom:true, _ts:Date.now()})
                            }}
                        >View orders</a>,

                        isConfirm && <React.Fragment key={4}>
                        <button
                            data-name="orders-link"
                            className="btn btn-link text-bold"
                            onClick={(e) => {
                                showModal({
                                    view: 'holdings',
                                    acctNo: detail.accountNo,
                                    source: e.target,
                                })
                            }}
                        >View portfolio</button>
                        </React.Fragment>,
                    ]
                    .filter(Boolean)
                    .flatMap( (a,i) => [a, <Sep key={i} />])
                    .slice(0, -1)
                    }
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
            </div>

        </div>
        </React.Fragment>
}

const Sep = () => <span aria-hidden={true} style={{padding:'0 10px 0 10px'}}>|</span>

const actionType = {
    'F': {label:'Offer Quote Request', color:'green'},
    'B': {color:'green'},
    'W': {label:'Bid Quote Request', color:'red'},
    'S': {color:'red'},
}

const actionTypeColor = (action) => (actionType[action] || {}).color || ''